import { useMemo } from 'react';
import { CurrencyIconImage } from '~/assets/collections/currency';
import { Currency } from '~/shared';

const useWalletIcon = (currency: Currency, isRounded?: boolean) => {
	return useMemo(() => {
		if (!CurrencyIconImage[currency]) {
			console.error('Invalid currency:', currency);
			return null;
		}

		if (isRounded) {
			return CurrencyIconImage[currency].rounded || null;
		}

		return CurrencyIconImage[currency].default || null;
	}, [currency, isRounded]);
};

export { useWalletIcon };
